import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const apiClient = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

export const createContact = (payload) => apiClient.post("/contact", payload).then((r) => r.data);
export const listCaseStudies = (tipo) => apiClient.get("/case-studies", { params: tipo ? { tipo } : {} }).then((r) => r.data);
export const getCaseStudy = (slug) => apiClient.get(`/case-studies/${slug}`).then((r) => r.data);
export const analyzeHiringScan = (payload) => apiClient.post("/hiring-scan/analyze", payload).then((r) => r.data);
export const unlockHiringScan = (payload) => apiClient.post("/hiring-scan/unlock", payload).then((r) => r.data);

// Admin
const adminHeaders = (token) => ({ headers: { "X-Admin-Token": token } });
export const adminVerify = (token) => apiClient.post("/admin/verify", {}, adminHeaders(token)).then((r) => r.data);
export const adminCreateCase = (payload, token) => apiClient.post("/admin/case-studies", payload, adminHeaders(token)).then((r) => r.data);
export const adminUpdateCase = (slug, payload, token) => apiClient.put(`/admin/case-studies/${slug}`, payload, adminHeaders(token)).then((r) => r.data);
export const adminDeleteCase = (slug, token) => apiClient.delete(`/admin/case-studies/${slug}`, adminHeaders(token)).then((r) => r.data);

// Team
export const listTeam = () => apiClient.get("/team").then((r) => r.data);
export const adminCreateTeam = (payload, token) => apiClient.post("/admin/team", payload, adminHeaders(token)).then((r) => r.data);
export const adminUpdateTeam = (id, payload, token) => apiClient.put(`/admin/team/${id}`, payload, adminHeaders(token)).then((r) => r.data);
export const adminDeleteTeam = (id, token) => apiClient.delete(`/admin/team/${id}`, adminHeaders(token)).then((r) => r.data);
export const adminTeamRemoveBg = (id, token) => apiClient.post(`/admin/team/${id}/remove-bg`, {}, { ...adminHeaders(token), timeout: 120000 }).then((r) => r.data);
export const adminTeamRemoveBgAll = (token) => apiClient.post(`/admin/team/remove-bg-all`, {}, adminHeaders(token)).then((r) => r.data);
export const adminTeamRemoveBgStatus = (token) => apiClient.get(`/admin/team/remove-bg-status`, adminHeaders(token)).then((r) => r.data);

export const LOGO_URL =
  "/images/logo-orizzontale.png";
